import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useStrings } from '../locales';

export default function ScrollToTopBtn() {
  const s = useStrings();
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const el = document.querySelector('.content-area');
    if (!el) return;
    const onScroll = () => setVisible(el.scrollTop > 300);
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => {
    const el = document.querySelector('.content-area');
    if (el) el.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <>
      <button onClick={scrollUp} className="scroll-top-btn" aria-label={s.scrollToTop}>
        <ArrowUp />
      </button>
      <button onClick={scrollUp} className="scroll-top-btn scroll-top-btn--left" aria-label={s.scrollToTop}>
        <ArrowUp />
      </button>
    </>
  );
}
